// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: true,
//   localUrl: 'http://localhost:4200/',
//   API_URL:  'http://localhost:8080/api/',//'http://172.31.19.102:8080/api/',//'http://localhost:8080/api/',
//   GOOGLE_MAPS_KEY: 'AIzaSyCfJlWe1z87ynbCGSirRQS3Kgme37KmQGE',
//   auth0: {
//     domain: 'dev-587zetfx5ww50ccs.us.auth0.com',//'dev-rct0470f5gshctlt.us.auth0.com',
//     clientId: 'ougnxaCtpLEuI5Cxwat5dJyBFF462kU0',//'fkWIjLyjOeGul72xjN3pgChyVQrkaZkh',
//     authorizationParams: {
//       audience: 'https://dev-587zetfx5ww50ccs.us.auth0.com/api/v2/',//'https://dev-rct0470f5gshctlt.us.auth0.com/api/v2/',
//       redirect_uri: 'http://localhost:4200/callback',
//     },
//   },
//   api: {
//     serverUrl: 'http://localhost:6060/', // demo auth0 api    
//   },
// };

// // PROD
export const environment = {
  production: true,
  localUrl: 'https://manageapogee.com/',
  API_URL:  'https://manageapogee.com/api/',//'http://172.31.19.102:8080/api/',//'http://localhost:8080/api/',
  GOOGLE_MAPS_KEY: 'AIzaSyCfJlWe1z87ynbCGSirRQS3Kgme37KmQGE',
  auth0: {
    domain: 'dev-587zetfx5ww50ccs.us.auth0.com',//'dev-rct0470f5gshctlt.us.auth0.com',
    clientId: 'ougnxaCtpLEuI5Cxwat5dJyBFF462kU0',//'fkWIjLyjOeGul72xjN3pgChyVQrkaZkh',
    authorizationParams: {
      audience: 'https://dev-587zetfx5ww50ccs.us.auth0.com/api/v2/',//'https://dev-rct0470f5gshctlt.us.auth0.com/api/v2/',
      redirect_uri: 'https://manageapogee.com/callback',
    },
  },
  api: {
    serverUrl: 'http://localhost:6060/', // demo auth0 api    
  },
};

